export function getCompositionImage(ingredientGroup, ingredientId) {
  console.log("getCompositionImage");
  if (ingredientGroup) {
    let ingredient = ingredientGroup.ingredients.filter(
      i => i.id === ingredientId
    );
    if (ingredient[0].composition_image) {
      return ingredient[0].composition_image;
    } else if (ingredient[0].image) {
      return ingredient[0].image;
    } else {
      return "";
    }
  }
}

/**
 *
 * @param ingredientGroup
 * @param ingredients
 * @returns {*[]}
 */
export function generateCompositionImageGroupItems(
  ingredientGroup,
  ingredients
) {
  let result = [];
  let ingredient_counter = 0;
  ingredients.forEach(ingredient => {
    if (ingredient.count > 0) {
      for (let index = 1; index <= ingredient.count; index++) {
        let composer_position_data =
          ingredientGroup["composer_position_data"][ingredient_counter];
        if (composer_position_data) {
          result.push({
            id: ingredient.id,
            item_key: ingredient.id + "_" + index,
            composition_image: getCompositionImage(
              ingredientGroup,
              ingredient.id
            ),
            position: composer_position_data
          });
        }
        ingredient_counter++;
      }
    }
  });
  return result;
}

/**
 * Used in ComboProductImage.vue, edit.vue, ingredientWizard.vue, ProductItem.vue
 * 1. relevant only if current product contains ingredients
 * 2. called on 'changeIngredient'
 *
 * Example
 * 1. product "Hoorntje" containing ingredient groups ("Hoorntje", "Ice cream", "Extras")
 * 2. only ingredient group "Hoorntje" contains position data
 *
 * @param product current product used in wizard
 * @returns {*[]} list of CompositionImageGroups
 */
export function generateCompositionImageGroups(product) {
  console.log("generateCompositionImageGroups");
  let result = [];
  if (product.ingredients) {
    product.available_ingredient_groups.forEach(aig => {
      if (
        aig["composer_position_data"] &&
        aig["composer_position_data"].length > 0
      ) {
        let imageGroup = {
          groupId: aig.id,
          orderBy: aig.order_by,
          items: generateCompositionImageGroupItems(
            aig,
            product.ingredients[aig.id]
          )
        };
        result.push(imageGroup);
      }
    });
    result.sort((c1, c2) => {
      return c2.orderBy - c1.orderBy;
    });
  }
  console.log(
    "generateCompositionImageGroups result = " + JSON.stringify(result)
  );
  return result;
}

export function getMaxCompositionImageHeight(compositionImageGroups) {
  let result = 0;
  let heights = [];
  if (compositionImageGroups) {
    compositionImageGroups.forEach(cig => {
      cig.items.forEach(item => {
        heights.push(item.position.top + item.position.height);
      });
    });
    result = Math.max(...heights);
  }
  return result;
}

export function getMaxProductImgHeight(product) {
  let img = product.ingredient_wizard_composition_image;
  let pos = product.ingredient_wizard_composition_image_position;
  if (img && pos) {
    return pos.height + pos.top;
  } else {
    return 0;
  }
}

// TODO documentation
// calculate min top offset of all composition images
export function getMinTopOffset(compositionImageGroups, product) {
  let top_offsets = [];
  if (
    product &&
    product.ingredient_wizard_composition_image &&
    product.ingredient_wizard_composition_image_position &&
    Number.isInteger(product.ingredient_wizard_composition_image_position.top)
  ) {
    console.log(
      "getMinTopOffset product.ingredient_wizard_composition_image_position.top = " +
        product.ingredient_wizard_composition_image_position.top
    );
    top_offsets.push(product.ingredient_wizard_composition_image_position.top);
  }
  if (compositionImageGroups) {
    compositionImageGroups.forEach(cig => {
      cig.items.forEach(item => {
        if (Number.isInteger(item.position.top)) {
          console.log(
            "getMinTopOffset item.position.top = " + item.position.top
          );
          top_offsets.push(item.position.top);
        }
      });
    });
  }
  if (top_offsets.length > 0) {
    console.log("getMinTopOffset from top_offsets = " + Math.min(...top_offsets))
    return Math.min(...top_offsets);
  } else {
    return 0;
  }
}
